import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { URLS } from '../constants/constants';
import { HeaderType, StorageKeys } from '../enums/enums';
import { ProfileDetails } from '../models/profile.model';
import { StorageService } from './storage.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private $profileDetails: BehaviorSubject<ProfileDetails | null> =
    new BehaviorSubject<ProfileDetails | null>(null);
  profileDetails = this.$profileDetails.asObservable();

  constructor(
    private storageService: StorageService,
    private http: HttpService
  ) {}

  setProfileDetails(data: ProfileDetails) {
    this.$profileDetails.next(data);
    this.storageService.setItem(StorageKeys.userRole, data.role);
  }

  getProfileDetails(): ProfileDetails | null {
    return this.$profileDetails.value;
  }

  fetchProfile(): Observable<{ profile: ProfileDetails }> {
    return this.http.get(`${URLS.profile}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }
}
